<template>
  <div v-if="resetPasswordSuccess">
    <AuthConfirmation
      :title="t('auth.reset_password.confirmation.title')"
      :underTitle="t('auth.reset_password.confirmation.under_title')"
      :confirm-button-text="t('auth.reset_password.confirmation.confirm_button_text')"
      @confirm="onBackToSignIn"
    />
  </div>

  <ResetPasswordForm v-else :loading="loading" @submit="onSubmit" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useAuthenticator } from '@infuse/auth/services';
import { ResetPasswordForm, AuthConfirmation } from '@infuse/auth/ui';
import { useNotify } from '@infuse/ui/services';
import { UiNotificationType } from '@infuse/ui/domain';

const { t } = useI18n();
const router = useRouter();
const notify = useNotify();

const loading = ref(false);
const resetPasswordSuccess = ref(false);

async function onSubmit(form: { username: string; password: string; code: string }) {
  loading.value = true;

  try {
    await useAuthenticator().forgotPasswordConfirm(form.username, form.password, form.code);

    resetPasswordSuccess.value = true;
  } catch (e) {
    notify({
      type: UiNotificationType.ERROR,
      group: 'notify-top',
      title: t('auth.notification.reset_unsuccessful_title'),
      message: t('auth.notification.reset_unsuccessful_message'),
      timeout: 5000
    });
  } finally {
    loading.value = false;
  }
}

function onBackToSignIn() {
  router.replace('/auth/sign-in');
}
</script>
